import apiClient from '../../../config/api';

export interface LoginRequest {
  email_user: string;
  password_user: string;
  captchaToken?: string;
}

export interface GoogleLoginRequest {
  credential: string;
}

export interface MicrosoftLoginRequest {
  code: string;
  redirectUri: string;
}

export interface LoginResponse {
  user: {
    userId: string;
    name: string;
    surname: string;
    email: string;
    role: string;
    packageType?: string | null;
  };
  token: string;
}

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
    
    // Guardar token en localStorage
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
    }
    
    return response.data;
  }

  async googleLogin(googleToken: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/google', {
      credential: googleToken,
    });
    
    // Guardar token en localStorage
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
    }
    
    return response.data;
  }

  async microsoftLogin(code: string, redirectUri: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/auth/microsoft', {
      code,
      redirectUri,
    });
    
    // Guardar token en localStorage
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
    }
    
    return response.data;
  }

  async logout(): Promise<void> {
    localStorage.removeItem('authToken');
  }

  async forgotPassword(email: string): Promise<{ message: string }> {
    // Sin `brand`: la marca del correo la decide el backend a partir de la
    // cuenta del destinatario. El enlace lleva dentro el dominio de la marca,
    // así que elegirla desde aquí permitía mandar a alguien al dominio de otro
    // distribuidor con un token válido.
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  }

  async resetPassword(token: string, password: string): Promise<{ message: string }> {
    const response = await apiClient.post('/auth/reset-password', { token, password });
    return response.data;
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('authToken');
  }
}

export default new AuthService();
